import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Input } from "reactstrap";

const MobileAuthModal = ({ isOpen, onSubmit, restaurantName }) => {
  const [mobileNumber, setMobileNumber] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    const cleaned = mobileNumber.trim().replace(/\D/g, "");
    if (!/^[6-9]\d{9}$/.test(cleaned)) {
      setError("Please enter a valid 10-digit mobile number.");
      return;
    }
    setError("");
    onSubmit(cleaned);
  };

  return (
    <Modal isOpen={isOpen} backdrop="static" keyboard={false} centered className="mobile-auth-modal">
      <ModalHeader className="bg-primary text-white text-center">
        Welcome to {restaurantName || "Our Restaurant"}
      </ModalHeader>
      <form onSubmit={handleSubmit}>
        <ModalBody className="p-4 text-center">
          <div className="mb-3">
            <span style={{ fontSize: "2.5rem" }}>📱</span>
          </div>
          <h5 className="fw-bold mb-2">Enter Your Mobile Number</h5>
          <p className="text-muted small mb-4">
            Required to place orders and track your order status live.
          </p>
          <div className="input-group mb-2">
            <span className="input-group-text fw-bold">+91</span>
            <Input
              type="tel"
              maxLength="10"
              placeholder="Enter 10-digit mobile number"
              value={mobileNumber}
              onChange={(e) => {
                setMobileNumber(e.target.value);
                if (error) setError("");
              }}
              autoFocus
            />
          </div>
          {error && <small className="text-danger d-block text-start mb-2">{error}</small>}
        </ModalBody>
        <ModalFooter className="d-flex justify-content-center border-0 pt-0 pb-4">
          <Button color="primary" block type="submit" className="px-5 py-2 fw-bold rounded-pill">
            Continue to Order &rarr;
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  );
};

export default MobileAuthModal;
